module.exports = __webpack_public_path__ + "static/media/1.3bf5cf4e.jpg";